"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var n = require("styled-components"),
    t = require("react"),
    e = require("redux-persist");

function r(n) {
  return n && "object" == typeof n && "default" in n ? n : {
    default: n
  };
}

var o = r(n),
    u = r(t),
    _i = function i() {
  return (_i = Object.assign || function (n) {
    for (var t, e = 1, r = arguments.length; e < r; e++) {
      for (var o in t = arguments[e]) {
        Object.prototype.hasOwnProperty.call(t, o) && (n[o] = t[o]);
      }
    }

    return n;
  }).apply(this, arguments);
};

function c() {
  for (var n = 0, t = 0, e = arguments.length; t < e; t++) {
    n += arguments[t].length;
  }

  var r = Array(n),
      o = 0;

  for (t = 0; t < e; t++) {
    for (var u = arguments[t], i = 0, c = u.length; i < c; i++, o++) {
      r[o] = u[i];
    }
  }

  return r;
}

function a(n, t) {
  return Object.defineProperty ? Object.defineProperty(n, "raw", {
    value: t
  }) : n.raw = t, n;
}

function f(n) {
  return null != n && "object" == typeof n && !0 === n["@@functional/placeholder"];
}

function l(n) {
  return function t(e) {
    return 0 === arguments.length || f(e) ? t : n.apply(this, arguments);
  };
}

function s(n) {
  return function t(e, r) {
    switch (arguments.length) {
      case 0:
        return t;

      case 1:
        return f(e) ? t : l(function (t) {
          return n(e, t);
        });

      default:
        return f(e) && f(r) ? t : f(e) ? l(function (t) {
          return n(t, r);
        }) : f(r) ? l(function (t) {
          return n(e, t);
        }) : n(e, r);
    }
  };
}

function p(n, t) {
  switch (n) {
    case 0:
      return function () {
        return t.apply(this, arguments);
      };

    case 1:
      return function (n) {
        return t.apply(this, arguments);
      };

    case 2:
      return function (n, e) {
        return t.apply(this, arguments);
      };

    case 3:
      return function (n, e, r) {
        return t.apply(this, arguments);
      };

    case 4:
      return function (n, e, r, o) {
        return t.apply(this, arguments);
      };

    case 5:
      return function (n, e, r, o, u) {
        return t.apply(this, arguments);
      };

    case 6:
      return function (n, e, r, o, u, i) {
        return t.apply(this, arguments);
      };

    case 7:
      return function (n, e, r, o, u, i, c) {
        return t.apply(this, arguments);
      };

    case 8:
      return function (n, e, r, o, u, i, c, a) {
        return t.apply(this, arguments);
      };

    case 9:
      return function (n, e, r, o, u, i, c, a, f) {
        return t.apply(this, arguments);
      };

    case 10:
      return function (n, e, r, o, u, i, c, a, f, l) {
        return t.apply(this, arguments);
      };

    default:
      throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
  }
}

function d(n, t, e) {
  return function () {
    for (var r = [], o = 0, u = n, i = 0; i < t.length || o < arguments.length;) {
      var c;
      i < t.length && (!f(t[i]) || o >= arguments.length) ? c = t[i] : (c = arguments[o], o += 1), r[i] = c, f(c) || (u -= 1), i += 1;
    }

    return u <= 0 ? e.apply(this, r) : p(u, d(n, r, e));
  };
}

var h = s(function (n, t) {
  return 1 === n ? l(t) : p(n, d(n, [], t));
});

function g(n) {
  return function t(e, r, o) {
    switch (arguments.length) {
      case 0:
        return t;

      case 1:
        return f(e) ? t : s(function (t, r) {
          return n(e, t, r);
        });

      case 2:
        return f(e) && f(r) ? t : f(e) ? s(function (t, e) {
          return n(t, r, e);
        }) : f(r) ? s(function (t, r) {
          return n(e, t, r);
        }) : l(function (t) {
          return n(e, r, t);
        });

      default:
        return f(e) && f(r) && f(o) ? t : f(e) && f(r) ? s(function (t, e) {
          return n(t, e, o);
        }) : f(e) && f(o) ? s(function (t, e) {
          return n(t, r, e);
        }) : f(r) && f(o) ? s(function (t, r) {
          return n(e, t, r);
        }) : f(e) ? l(function (t) {
          return n(t, r, o);
        }) : f(r) ? l(function (t) {
          return n(e, t, o);
        }) : f(o) ? l(function (t) {
          return n(e, r, t);
        }) : n(e, r, o);
    }
  };
}

var m = Array.isArray || function (n) {
  return null != n && n.length >= 0 && "[object Array]" === Object.prototype.toString.call(n);
};

function y(n) {
  return null != n && "function" == typeof n["@@transducer/step"];
}

function v(n, t, e) {
  return function () {
    if (0 === arguments.length) return e();
    var r = Array.prototype.slice.call(arguments, 0),
        o = r.pop();

    if (!m(o)) {
      for (var u = 0; u < n.length;) {
        if ("function" == typeof o[n[u]]) return o[n[u]].apply(o, r);
        u += 1;
      }

      if (y(o)) {
        var i = t.apply(null, r);
        return i(o);
      }
    }

    return e.apply(this, arguments);
  };
}

var w = function w() {
  return this.xf["@@transducer/init"]();
},
    x = function x(n) {
  return this.xf["@@transducer/result"](n);
};

function b(n) {
  return "[object String]" === Object.prototype.toString.call(n);
}

var S = l(function (n) {
  return !!m(n) || !!n && "object" == typeof n && !b(n) && (1 === n.nodeType ? !!n.length : 0 === n.length || n.length > 0 && n.hasOwnProperty(0) && n.hasOwnProperty(n.length - 1));
}),
    O = function () {
  function n(n) {
    this.f = n;
  }

  return n.prototype["@@transducer/init"] = function () {
    throw new Error("init not implemented on XWrap");
  }, n.prototype["@@transducer/result"] = function (n) {
    return n;
  }, n.prototype["@@transducer/step"] = function (n, t) {
    return this.f(n, t);
  }, n;
}();

var j = s(function (n, t) {
  return p(n.length, function () {
    return n.apply(t, arguments);
  });
});

function I(n, t, e) {
  for (var r = e.next(); !r.done;) {
    if ((t = n["@@transducer/step"](t, r.value)) && t["@@transducer/reduced"]) {
      t = t["@@transducer/value"];
      break;
    }

    r = e.next();
  }

  return n["@@transducer/result"](t);
}

function M(n, t, e, r) {
  return n["@@transducer/result"](e[r](j(n["@@transducer/step"], n), t));
}

var E = "undefined" != typeof Symbol ? Symbol.iterator : "@@iterator";

function R(n, t, e) {
  if ("function" == typeof n && (n = function (n) {
    return new O(n);
  }(n)), S(e)) return function (n, t, e) {
    for (var r = 0, o = e.length; r < o;) {
      if ((t = n["@@transducer/step"](t, e[r])) && t["@@transducer/reduced"]) {
        t = t["@@transducer/value"];
        break;
      }

      r += 1;
    }

    return n["@@transducer/result"](t);
  }(n, t, e);
  if ("function" == typeof e["fantasy-land/reduce"]) return M(n, t, e, "fantasy-land/reduce");
  if (null != e[E]) return I(n, t, e[E]());
  if ("function" == typeof e.next) return I(n, t, e);
  if ("function" == typeof e.reduce) return M(n, t, e, "reduce");
  throw new TypeError("reduce: list must be array or iterable");
}

var P = function () {
  function n(n, t) {
    this.xf = t, this.f = n;
  }

  return n.prototype["@@transducer/init"] = w, n.prototype["@@transducer/result"] = x, n.prototype["@@transducer/step"] = function (n, t) {
    return this.xf["@@transducer/step"](n, this.f(t));
  }, n;
}(),
    A = s(function (n, t) {
  return new P(n, t);
});

function U(n, t) {
  return Object.prototype.hasOwnProperty.call(t, n);
}

var C,
    N,
    W,
    _,
    B,
    L,
    F,
    T,
    k,
    z,
    q,
    H,
    D,
    V,
    X,
    K,
    G,
    J,
    Q,
    Y,
    Z,
    $,
    nn,
    tn,
    en,
    rn,
    on,
    un,
    cn,
    an,
    fn = Object.prototype.toString,
    ln = function () {
  return "[object Arguments]" === fn.call(arguments) ? function (n) {
    return "[object Arguments]" === fn.call(n);
  } : function (n) {
    return U("callee", n);
  };
}(),
    sn = !{
  toString: null
}.propertyIsEnumerable("toString"),
    pn = ["constructor", "valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"],
    dn = function () {
  return arguments.propertyIsEnumerable("length");
}(),
    hn = function hn(n, t) {
  for (var e = 0; e < n.length;) {
    if (n[e] === t) return !0;
    e += 1;
  }

  return !1;
},
    gn = "function" != typeof Object.keys || dn ? l(function (n) {
  if (Object(n) !== n) return [];
  var t,
      e,
      r = [],
      o = dn && ln(n);

  for (t in n) {
    !U(t, n) || o && "length" === t || (r[r.length] = t);
  }

  if (sn) for (e = pn.length - 1; e >= 0;) {
    U(t = pn[e], n) && !hn(r, t) && (r[r.length] = t), e -= 1;
  }
  return r;
}) : l(function (n) {
  return Object(n) !== n ? [] : Object.keys(n);
}),
    mn = s(v(["fantasy-land/map", "map"], A, function (n, t) {
  switch (Object.prototype.toString.call(t)) {
    case "[object Function]":
      return h(t.length, function () {
        return n.call(this, t.apply(this, arguments));
      });

    case "[object Object]":
      return R(function (e, r) {
        return e[r] = n(t[r]), e;
      }, {}, gn(t));

    default:
      return function (n, t) {
        for (var e = 0, r = t.length, o = Array(r); e < r;) {
          o[e] = n(t[e]), e += 1;
        }

        return o;
      }(n, t);
  }
})),
    yn = Number.isInteger || function (n) {
  return n << 0 === n;
},
    vn = s(function (n, t) {
  var e = n < 0 ? t.length + n : n;
  return b(t) ? t.charAt(e) : t[e];
}),
    wn = s(function (n, t) {
  return n.map(function (n) {
    for (var e, r = t, o = 0; o < n.length;) {
      if (null == r) return;
      e = n[o], r = yn(e) ? vn(e, r) : r[e], o += 1;
    }

    return r;
  });
}),
    xn = s(function (n, t) {
  return wn([n], t)[0];
}),
    bn = l(function (n) {
  return function () {
    return n;
  };
}),
    Sn = g(function (n, t, e) {
  var r = {};

  for (var o in e) {
    r[o] = e[o];
  }

  return r[n] = t, r;
}),
    On = l(function (n) {
  return null == n;
}),
    jn = g(function n(t, e, r) {
  if (0 === t.length) return e;
  var o = t[0];

  if (t.length > 1) {
    var u = !On(r) && U(o, r) ? r[o] : yn(t[1]) ? [] : {};
    e = n(Array.prototype.slice.call(t, 1), e, u);
  }

  if (yn(o) && m(r)) {
    var i = [].concat(r);
    return i[o] = e, i;
  }

  return Sn(o, e, r);
}),
    In = s(function (n, t) {
  return function (e) {
    return function (r) {
      return mn(function (n) {
        return t(n, r);
      }, e(n(r)));
    };
  };
}),
    Mn = l(function (n) {
  return In(xn(n), jn(n));
}),
    En = function En(n) {
  return {
    value: n,
    map: function map(t) {
      return En(t(n));
    }
  };
},
    Rn = g(function (n, t, e) {
  return n(function (n) {
    return En(t(n));
  })(e).value;
}),
    Pn = g(function (n, t, e) {
  return Rn(n, bn(t), e);
}),
    An = function An(n) {
  return function (t) {
    return function (e) {
      return !!xn(n.split("."), e) && t;
    };
  };
},
    Un = o.default.div(on || (on = a(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-content: stretch;\n\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-content: stretch;\n\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n"])), An("inline")(n.css(C || (C = a(["\n    display: inline-flex;\n  "], ["\n    display: inline-flex;\n  "])))), An("row")(n.css(N || (N = a(["\n    flex-direction: row; /* default */\n  "], ["\n    flex-direction: row; /* default */\n  "])))), An("rowReverse")(n.css(W || (W = a(["\n    flex-direction: row-reverse;\n  "], ["\n    flex-direction: row-reverse;\n  "])))), An("column")(n.css(_ || (_ = a(["\n    flex-direction: column;\n  "], ["\n    flex-direction: column;\n  "])))), An("columnReverse")(n.css(B || (B = a(["\n    flex-direction: column-reverse;\n  "], ["\n    flex-direction: column-reverse;\n  "])))), An("nowrap")(n.css(L || (L = a(["\n    flex-wrap: nowrap; /* default */\n  "], ["\n    flex-wrap: nowrap; /* default */\n  "])))), An("wrap")(n.css(F || (F = a(["\n    flex-wrap: wrap;\n  "], ["\n    flex-wrap: wrap;\n  "])))), An("wrapReverse")(n.css(T || (T = a(["\n    flex-wrap: wrap-reverse;\n  "], ["\n    flex-wrap: wrap-reverse;\n  "])))), An("justifyStart")(n.css(k || (k = a(["\n    justify-content: flex-start; /* default */\n  "], ["\n    justify-content: flex-start; /* default */\n  "])))), An("justifyEnd")(n.css(z || (z = a(["\n    justify-content: flex-end;\n  "], ["\n    justify-content: flex-end;\n  "])))), An("justifyCenter")(n.css(q || (q = a(["\n    justify-content: center;\n  "], ["\n    justify-content: center;\n  "])))), An("justifySpaceBetween")(n.css(H || (H = a(["\n    justify-content: space-between;\n  "], ["\n    justify-content: space-between;\n  "])))), An("justifySpaceAround")(n.css(D || (D = a(["\n    justify-content: space-around;\n  "], ["\n    justify-content: space-around;\n  "])))), An("contentStart")(n.css(V || (V = a(["\n    align-content: flex-start;\n  "], ["\n    align-content: flex-start;\n  "])))), An("contentEnd")(n.css(X || (X = a(["\n    align-content: flex-end;\n  "], ["\n    align-content: flex-end;\n  "])))), An("contentCenter")(n.css(K || (K = a(["\n    align-content: center;\n  "], ["\n    align-content: center;\n  "])))), An("contentSpaceBetween")(n.css(G || (G = a(["\n    align-content: space-between;\n  "], ["\n    align-content: space-between;\n  "])))), An("contentSpaceAround")(n.css(J || (J = a(["\n    align-content: space-around;\n  "], ["\n    align-content: space-around;\n  "])))), An("contentStretch")(n.css(Q || (Q = a(["\n    align-content: stretch; /* default */\n  "], ["\n    align-content: stretch; /* default */\n  "])))), An("alignStart")(n.css(Y || (Y = a(["\n    align-items: flex-start;\n  "], ["\n    align-items: flex-start;\n  "])))), An("alignEnd")(n.css(Z || (Z = a(["\n    align-items: flex-end;\n  "], ["\n    align-items: flex-end;\n  "])))), An("alignCenter")(n.css($ || ($ = a(["\n    align-items: center;\n  "], ["\n    align-items: center;\n  "])))), An("alignBaseline")(n.css(nn || (nn = a(["\n    align-items: baseline;\n  "], ["\n    align-items: baseline;\n  "])))), An("alignStretch")(n.css(tn || (tn = a(["\n    align-items: stretch;\n  "], ["\n    align-items: stretch;\n  "])))), An("full")(n.css(en || (en = a(["\n    width: 100%;\n    height: 100%;\n  "], ["\n    width: 100%;\n    height: 100%;\n  "])))), An("center")(n.css(rn || (rn = a(["\n    align-items: center;\n    justify-content: center;\n  "], ["\n    align-items: center;\n    justify-content: center;\n  "]))))),
    Cn = o.default.div(un || (un = a(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  min-height: 100vh;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  min-height: 100vh;\n"]))),
    Nn = o.default.div(cn || (cn = a(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n"])));

(an = exports.IconSize || (exports.IconSize = {}))[an.ExtraSmall = 0] = "ExtraSmall", an[an.Small = 1] = "Small", an[an.Medium = 2] = "Medium", an[an.Large = 3] = "Large";

function Wn(n) {
  return n.hasOwnProperty("error") && n.hasOwnProperty("error_description");
}

function _n(n) {
  return n.hasOwnProperty("errors") && Array.isArray(n.errors);
}

var Bn = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function Ln(n) {
  var t = {
    exports: {}
  };
  return n(t, t.exports), t.exports;
}

var Fn = Ln(function (n, t) {
  function e(n) {
    return n;
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.untupled = t.tupled = t.absurd = t.decrement = t.increment = t.tuple = t.flow = t.flip = t.constVoid = t.constUndefined = t.constNull = t.constFalse = t.constTrue = t.constant = t.not = t.unsafeCoerce = t.identity = void 0, t.identity = e, t.unsafeCoerce = e, t.not = function (n) {
    return function (t) {
      return !n(t);
    };
  }, t.constant = function (n) {
    return function () {
      return n;
    };
  }, t.constTrue = function () {
    return !0;
  }, t.constFalse = function () {
    return !1;
  }, t.constNull = function () {
    return null;
  }, t.constUndefined = function () {}, t.constVoid = function () {}, t.flip = function (n) {
    return function (t, e) {
      return n(e, t);
    };
  }, t.flow = function (n, t, e, r, o, u, i, c, a) {
    switch (arguments.length) {
      case 1:
        return n;

      case 2:
        return function () {
          return t(n.apply(this, arguments));
        };

      case 3:
        return function () {
          return e(t(n.apply(this, arguments)));
        };

      case 4:
        return function () {
          return r(e(t(n.apply(this, arguments))));
        };

      case 5:
        return function () {
          return o(r(e(t(n.apply(this, arguments)))));
        };

      case 6:
        return function () {
          return u(o(r(e(t(n.apply(this, arguments))))));
        };

      case 7:
        return function () {
          return i(u(o(r(e(t(n.apply(this, arguments)))))));
        };

      case 8:
        return function () {
          return c(i(u(o(r(e(t(n.apply(this, arguments))))))));
        };

      case 9:
        return function () {
          return a(c(i(u(o(r(e(t(n.apply(this, arguments)))))))));
        };
    }
  }, t.tuple = function () {
    for (var n = [], t = 0; t < arguments.length; t++) {
      n[t] = arguments[t];
    }

    return n;
  }, t.increment = function (n) {
    return n + 1;
  }, t.decrement = function (n) {
    return n - 1;
  }, t.absurd = function (n) {
    throw new Error("Called `absurd` function which should be uncallable");
  }, t.tupled = function (n) {
    return function (t) {
      return n.apply(void 0, t);
    };
  }, t.untupled = function (n) {
    return function () {
      for (var t = [], e = 0; e < arguments.length; e++) {
        t[e] = arguments[e];
      }

      return n(t);
    };
  };
}),
    Tn = Ln(function (n, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.pipeable = t.pipe = void 0, t.pipe = function (n, t, e, r, o, u, i, c, a, f) {
    switch (arguments.length) {
      case 1:
        return n;

      case 2:
        return t(n);

      case 3:
        return e(t(n));

      case 4:
        return r(e(t(n)));

      case 5:
        return o(r(e(t(n))));

      case 6:
        return u(o(r(e(t(n)))));

      case 7:
        return i(u(o(r(e(t(n))))));

      case 8:
        return c(i(u(o(r(e(t(n)))))));

      case 9:
        return a(c(i(u(o(r(e(t(n))))))));

      case 10:
        return f(a(c(i(u(o(r(e(t(n)))))))));
    }
  };

  t.pipeable = function (n) {
    var t = {};

    if (function (n) {
      return "function" == typeof n.map;
    }(n)) {
      t.map = function (t) {
        return function (e) {
          return n.map(e, t);
        };
      };
    }

    if (function (n) {
      return "function" == typeof n.contramap;
    }(n)) {
      t.contramap = function (t) {
        return function (e) {
          return n.contramap(e, t);
        };
      };
    }

    if (function (n) {
      return "function" == typeof n.mapWithIndex;
    }(n)) {
      t.mapWithIndex = function (t) {
        return function (e) {
          return n.mapWithIndex(e, t);
        };
      };
    }

    if (function (n) {
      return "function" == typeof n.ap;
    }(n)) {
      t.ap = function (t) {
        return function (e) {
          return n.ap(e, t);
        };
      }, t.apFirst = function (t) {
        return function (e) {
          return n.ap(n.map(e, function (n) {
            return function () {
              return n;
            };
          }), t);
        };
      }, t.apSecond = function (t) {
        return function (e) {
          return n.ap(n.map(e, function () {
            return function (n) {
              return n;
            };
          }), t);
        };
      };
    }

    if (function (n) {
      return "function" == typeof n.chain;
    }(n)) {
      t.chain = function (t) {
        return function (e) {
          return n.chain(e, t);
        };
      }, t.chainFirst = function (t) {
        return function (e) {
          return n.chain(e, function (e) {
            return n.map(t(e), function () {
              return e;
            });
          });
        };
      }, t.flatten = function (t) {
        return n.chain(t, Fn.identity);
      };
    }

    if (function (n) {
      return "function" == typeof n.bimap;
    }(n)) {
      t.bimap = function (t, e) {
        return function (r) {
          return n.bimap(r, t, e);
        };
      }, t.mapLeft = function (t) {
        return function (e) {
          return n.mapLeft(e, t);
        };
      };
    }

    if (function (n) {
      return "function" == typeof n.extend;
    }(n)) {
      t.extend = function (t) {
        return function (e) {
          return n.extend(e, t);
        };
      }, t.duplicate = function (t) {
        return n.extend(t, Fn.identity);
      };
    }

    if (function (n) {
      return "function" == typeof n.reduce;
    }(n)) {
      t.reduce = function (t, e) {
        return function (r) {
          return n.reduce(r, t, e);
        };
      }, t.foldMap = function (t) {
        var e = n.foldMap(t);
        return function (n) {
          return function (t) {
            return e(t, n);
          };
        };
      }, t.reduceRight = function (t, e) {
        return function (r) {
          return n.reduceRight(r, t, e);
        };
      };
    }

    if (function (n) {
      return "function" == typeof n.reduceWithIndex;
    }(n)) {
      t.reduceWithIndex = function (t, e) {
        return function (r) {
          return n.reduceWithIndex(r, t, e);
        };
      }, t.foldMapWithIndex = function (t) {
        var e = n.foldMapWithIndex(t);
        return function (n) {
          return function (t) {
            return e(t, n);
          };
        };
      }, t.reduceRightWithIndex = function (t, e) {
        return function (r) {
          return n.reduceRightWithIndex(r, t, e);
        };
      };
    }

    if (function (n) {
      return "function" == typeof n.alt;
    }(n)) {
      t.alt = function (t) {
        return function (e) {
          return n.alt(e, t);
        };
      };
    }

    if (function (n) {
      return "function" == typeof n.compact;
    }(n) && (t.compact = n.compact, t.separate = n.separate), function (n) {
      return "function" == typeof n.filter;
    }(n)) {
      t.filter = function (t) {
        return function (e) {
          return n.filter(e, t);
        };
      }, t.filterMap = function (t) {
        return function (e) {
          return n.filterMap(e, t);
        };
      }, t.partition = function (t) {
        return function (e) {
          return n.partition(e, t);
        };
      }, t.partitionMap = function (t) {
        return function (e) {
          return n.partitionMap(e, t);
        };
      };
    }

    if (function (n) {
      return "function" == typeof n.filterWithIndex;
    }(n)) {
      t.filterWithIndex = function (t) {
        return function (e) {
          return n.filterWithIndex(e, t);
        };
      }, t.filterMapWithIndex = function (t) {
        return function (e) {
          return n.filterMapWithIndex(e, t);
        };
      }, t.partitionWithIndex = function (t) {
        return function (e) {
          return n.partitionWithIndex(e, t);
        };
      }, t.partitionMapWithIndex = function (t) {
        return function (e) {
          return n.partitionMapWithIndex(e, t);
        };
      };
    }

    if (function (n) {
      return "function" == typeof n.promap;
    }(n)) {
      t.promap = function (t, e) {
        return function (r) {
          return n.promap(r, t, e);
        };
      };
    }

    if (function (n) {
      return "function" == typeof n.compose;
    }(n)) {
      t.compose = function (t) {
        return function (e) {
          return n.compose(e, t);
        };
      };
    }

    if (function (n) {
      return "function" == typeof n.throwError;
    }(n)) {
      t.fromOption = function (t) {
        return function (e) {
          return "None" === e._tag ? n.throwError(t()) : n.of(e.value);
        };
      }, t.fromEither = function (t) {
        return "Left" === t._tag ? n.throwError(t.left) : n.of(t.right);
      }, t.fromPredicate = function (t, e) {
        return function (r) {
          return t(r) ? n.of(r) : n.throwError(e(r));
        };
      }, t.filterOrElse = function (t, e) {
        return function (r) {
          return n.chain(r, function (r) {
            return t(r) ? n.of(r) : n.throwError(e(r));
          });
        };
      };
    }

    return t;
  };
}),
    kn = Ln(function (n, t) {
  var e = Bn && Bn.__assign || function () {
    return (e = Object.assign || function (n) {
      for (var t, e = 1, r = arguments.length; e < r; e++) {
        for (var o in t = arguments[e]) {
          Object.prototype.hasOwnProperty.call(t, o) && (n[o] = t[o]);
        }
      }

      return n;
    }).apply(this, arguments);
  };

  function r(n) {
    return {
      _tag: "Some",
      value: n
    };
  }

  function o(n) {
    return "Some" === n._tag;
  }

  function u(n) {
    return "None" === n._tag;
  }

  function i(n) {
    return null == n ? t.none : r(n);
  }

  function c(n) {
    return function (t) {
      return u(t) ? n() : t.value;
    };
  }

  function a(n) {
    return "Right" === n._tag ? t.none : r(n.left);
  }

  function f(n) {
    return "Left" === n._tag ? t.none : r(n.right);
  }

  function l(n) {
    return {
      equals: function equals(t, e) {
        return t === e || (u(t) ? u(e) : !u(e) && n.equals(t.value, e.value));
      }
    };
  }

  function s(n) {
    return {
      concat: function concat(e, u) {
        return o(e) && o(u) ? r(n.concat(e.value, u.value)) : t.none;
      }
    };
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.fromEither = t.separate = t.compact = t.reduceRight = t.reduce = t.partitionMap = t.partition = t.map = t.foldMap = t.flatten = t.filterMap = t.filter = t.extend = t.duplicate = t.chainFirst = t.chain = t.apSecond = t.apFirst = t.ap = t.alt = t.option = t.getMonoid = t.getLastMonoid = t.getFirstMonoid = t.getApplyMonoid = t.getApplySemigroup = t.getOrd = t.getEq = t.getShow = t.mapNullable = t.getRefinement = t.getRight = t.getLeft = t.tryCatch = t.fromPredicate = t.exists = t.elem = t.getOrElseW = t.getOrElse = t.toUndefined = t.toNullable = t.fromNullable = t.fold = t.isNone = t.isSome = t.some = t.none = t.URI = void 0, t.URI = "Option", t.none = {
    _tag: "None"
  }, t.some = r, t.isSome = o, t.isNone = u, t.fold = function (n, t) {
    return function (e) {
      return u(e) ? n() : t(e.value);
    };
  }, t.fromNullable = i, t.toNullable = function (n) {
    return u(n) ? null : n.value;
  }, t.toUndefined = function (n) {
    return u(n) ? void 0 : n.value;
  }, t.getOrElse = c, t.getOrElseW = c, t.elem = function (n) {
    return function (t, e) {
      return !u(e) && n.equals(t, e.value);
    };
  }, t.exists = function (n) {
    return function (t) {
      return !u(t) && n(t.value);
    };
  }, t.fromPredicate = function (n) {
    return function (e) {
      return n(e) ? r(e) : t.none;
    };
  }, t.tryCatch = function (n) {
    try {
      return r(n());
    } catch (n) {
      return t.none;
    }
  }, t.getLeft = a, t.getRight = f, t.getRefinement = function (n) {
    return function (t) {
      return o(n(t));
    };
  }, t.mapNullable = function (n) {
    return function (e) {
      return u(e) ? t.none : i(n(e.value));
    };
  }, t.getShow = function (n) {
    return {
      show: function show(t) {
        return u(t) ? "none" : "some(" + n.show(t.value) + ")";
      }
    };
  }, t.getEq = l, t.getOrd = function (n) {
    return {
      equals: l(n).equals,
      compare: function compare(t, e) {
        return t === e ? 0 : o(t) ? o(e) ? n.compare(t.value, e.value) : 1 : -1;
      }
    };
  }, t.getApplySemigroup = s, t.getApplyMonoid = function (n) {
    return e(e({}, s(n)), {
      empty: r(n.empty)
    });
  }, t.getFirstMonoid = function () {
    return {
      concat: function concat(n, t) {
        return u(n) ? t : n;
      },
      empty: t.none
    };
  }, t.getLastMonoid = function () {
    return {
      concat: function concat(n, t) {
        return u(t) ? n : t;
      },
      empty: t.none
    };
  }, t.getMonoid = function (n) {
    return {
      concat: function concat(t, e) {
        return u(t) ? e : u(e) ? t : r(n.concat(t.value, e.value));
      },
      empty: t.none
    };
  };

  var p = {
    left: t.none,
    right: t.none
  },
      d = function d(n) {
    return n;
  };

  t.option = {
    URI: t.URI,
    map: function map(n, e) {
      return u(n) ? t.none : r(e(n.value));
    },
    of: r,
    ap: function ap(n, e) {
      return u(n) || u(e) ? t.none : r(n.value(e.value));
    },
    chain: function chain(n, e) {
      return u(n) ? t.none : e(n.value);
    },
    reduce: function reduce(n, t, e) {
      return u(n) ? t : e(t, n.value);
    },
    foldMap: function foldMap(n) {
      return function (t, e) {
        return u(t) ? n.empty : e(t.value);
      };
    },
    reduceRight: function reduceRight(n, t, e) {
      return u(n) ? t : e(n.value, t);
    },
    traverse: function traverse(n) {
      return function (e, o) {
        return u(e) ? n.of(t.none) : n.map(o(e.value), r);
      };
    },
    sequence: function sequence(n) {
      return function (e) {
        return u(e) ? n.of(t.none) : n.map(e.value, r);
      };
    },
    zero: function zero() {
      return t.none;
    },
    alt: function alt(n, t) {
      return u(n) ? t() : n;
    },
    extend: function extend(n, e) {
      return u(n) ? t.none : r(e(n));
    },
    compact: function compact(n) {
      return t.option.chain(n, d);
    },
    separate: function separate(n) {
      var e = t.option.map(n, function (n) {
        return {
          left: a(n),
          right: f(n)
        };
      });
      return u(e) ? p : e.value;
    },
    filter: function filter(n, e) {
      return u(n) ? t.none : e(n.value) ? n : t.none;
    },
    filterMap: function filterMap(n, e) {
      return u(n) ? t.none : e(n.value);
    },
    partition: function partition(n, e) {
      return {
        left: t.option.filter(n, function (n) {
          return !e(n);
        }),
        right: t.option.filter(n, e)
      };
    },
    partitionMap: function partitionMap(n, e) {
      return t.option.separate(t.option.map(n, e));
    },
    wither: function wither(n) {
      return function (e, r) {
        return u(e) ? n.of(t.none) : r(e.value);
      };
    },
    wilt: function wilt(n) {
      return function (e, r) {
        var o = t.option.map(e, function (t) {
          return n.map(r(t), function (n) {
            return {
              left: a(n),
              right: f(n)
            };
          });
        });
        return u(o) ? n.of({
          left: t.none,
          right: t.none
        }) : o.value;
      };
    },
    throwError: function throwError() {
      return t.none;
    }
  };
  var h = Tn.pipeable(t.option),
      g = h.alt,
      m = h.ap,
      y = h.apFirst,
      v = h.apSecond,
      w = h.chain,
      x = h.chainFirst,
      b = h.duplicate,
      S = h.extend,
      O = h.filter,
      j = h.filterMap,
      I = h.flatten,
      M = h.foldMap,
      E = h.map,
      R = h.partition,
      P = h.partitionMap,
      A = h.reduce,
      U = h.reduceRight,
      C = h.compact,
      N = h.separate,
      W = h.fromEither;
  t.alt = g, t.ap = m, t.apFirst = y, t.apSecond = v, t.chain = w, t.chainFirst = x, t.duplicate = b, t.extend = S, t.filter = O, t.filterMap = j, t.flatten = I, t.foldMap = M, t.map = E, t.partition = R, t.partitionMap = P, t.reduce = A, t.reduceRight = U, t.compact = C, t.separate = N, t.fromEither = W;
}),
    zn = function zn(n, t) {
  var e = new FileReader();
  e.onload = function (n) {
    if (n.target) {
      var e = n.target,
          r = new DataView(e.result);
      if (65496 != r.getUint16(0, !1)) return t(void 0);

      for (var o = r.byteLength, u = 2; u < o;) {
        if (r.getUint16(u + 2, !1) <= 8) return t(-1);
        var i = r.getUint16(u, !1);

        if (u += 2, 65505 == i) {
          if (1165519206 != r.getUint32(u += 2, !1)) return t(void 0);
          var c = 18761 == r.getUint16(u += 6, !1);
          u += r.getUint32(u + 4, c);
          var a = r.getUint16(u, c);
          u += 2;

          for (var f = 0; f < a; f++) {
            if (274 == r.getUint16(u + 12 * f, c)) return t(r.getUint16(u + 12 * f + 8, c));
          }
        } else {
          if (65280 != (65280 & i)) break;
          u += r.getUint16(u, !1);
        }
      }

      return t(void 0);
    }
  }, e.readAsArrayBuffer(n);
},
    qn = "undefined" != typeof Blob && function () {
  try {
    return Boolean(new Blob());
  } catch (n) {
    return !1;
  }
}(),
    Hn = qn && "undefined" != typeof Uint8Array && function () {
  try {
    return 100 === new Blob([new Uint8Array(100)]).size;
  } catch (n) {
    return !1;
  }
}(),
    Dn = "undefined" != typeof HTMLCanvasElement && HTMLCanvasElement.prototype.toBlob,
    Vn = Dn || "undefined" != typeof Uint8Array && "undefined" != typeof ArrayBuffer && "undefined" != typeof atob,
    Xn = "undefined" != typeof FileReader || "undefined" != typeof URL,
    Kn = "undefined" != typeof HTMLCanvasElement,
    Gn = function Gn() {
  var n = this;
  this.isSupportedByBrowser = function () {
    return Kn && Vn && Xn;
  }, this.resize = function (t, e) {
    return new Promise(function (r) {
      if (!n.browserSupport || !t.type.match(/image.*/)) return r(t);
      if (t.type.match(/image\/gif/)) return r(t);
      var o = document.createElement("img");
      return o.onload = function () {
        var u = o.width,
            i = o.height;
        if (u >= i && u > e.width) i *= e.width / u, u = e.width;else {
          if (!(i > e.height)) return r(t);
          u *= e.height / i, i = e.height;
        }
        zn(t, function (e) {
          var c = n.drawImageToCanvas(o, e, 0, 0, u, i, "contain");
          Dn ? c.toBlob(function (n) {
            return r(n);
          }, t.type) : r(n.toBlob(c, t.type));
        });
      }, n.loadImage(o, t), !0;
    });
  }, this.crop = function (t, e) {
    return new Promise(function (r) {
      if (!n.browserSupport || !t.type.match(/image.*/)) return r(t);
      if (t.type.match(/image\/gif/)) return r(t);
      var o = document.createElement("img");
      return o.onload = function () {
        if (e.width > o.width && e.height > o.height) return r(t);
        var u = Math.min(e.width, o.width),
            i = Math.min(e.height, o.height);
        if (o.width > 2 * e.width || o.height > 2 * e.height) return n.resize(t, {
          width: 2 * e.width,
          height: 2 * e.height
        }).then(function (t) {
          t && n.crop(t, {
            width: u,
            height: i
          }).then(r);
        });
        zn(t, function (e) {
          var c = n.drawImageToCanvas(o, e, 0, 0, u, i, "crop");
          Dn ? c.toBlob(function (n) {
            return r(n);
          }, t.type) : r(n.toBlob(c, t.type));
        });
      }, n.loadImage(o, t), !0;
    });
  }, this.drawImageToCanvas = function (n, t, e, r, o, u, i) {
    void 0 === t && (t = 1), void 0 === e && (e = 0), void 0 === r && (r = 0), void 0 === o && (o = n.width), void 0 === u && (u = n.height), void 0 === i && (i = "contain");
    var c = document.createElement("canvas"),
        a = c.getContext("2d");

    switch (c.width = o, c.height = u, a.save(), Number(t)) {
      case 1:
        break;

      case 2:
        a.translate(o, 0), a.scale(-1, 1);
        break;

      case 3:
        a.translate(o, u), a.rotate(1 * Math.PI);
        break;

      case 4:
        a.translate(0, u), a.scale(1, -1);
        break;

      case 5:
        c.width = u, c.height = o, a.rotate(.5 * Math.PI), a.scale(1, -1);
        break;

      case 6:
        c.width = u, c.height = o, a.rotate(.5 * Math.PI), a.translate(0, -u);
        break;

      case 7:
        c.width = u, c.height = o, a.rotate(1.5 * Math.PI), a.translate(-o, u), a.scale(1, -1);
        break;

      case 8:
        c.width = u, c.height = o, a.translate(0, o), a.rotate(1.5 * Math.PI);
    }

    return "crop" === i ? a.drawImage(n, n.width / 2 - o / 2, n.height / 2 - u / 2, o, u, 0, 0, o, u) : a.drawImage(n, e, r, o, u), a.restore(), c;
  }, this.toBlob = function (n, t) {
    for (var e = n.toDataURL(t).split(","), r = e[0].indexOf("base64") >= 0 ? atob(e[1]) : decodeURIComponent(e[1]), o = new ArrayBuffer(r.length), u = new Uint8Array(o), i = 0; i < r.length; i += 1) {
      u[i] = r.charCodeAt(i);
    }

    var c = e[0].split(":")[1].split(";")[0],
        a = null;
    return qn && (a = new Blob([Hn ? u : o], {
      type: c
    })), a;
  }, this.loadImage = function (n, t) {
    if ("undefined" == typeof URL) {
      var e = new FileReader();
      e.onload = function (t) {
        n.src = t.target.result;
      }, e.readAsDataURL(t);
    } else n.src = URL.createObjectURL(t);
  }, this.browserSupport = this.isSupportedByBrowser();
},
    Jn = function Jn(n, t) {
  return t ? n + " " + t : n;
};

exports.Flex = Un, exports.FullSizeContainer = Cn, exports.HideOverflowContainer = Nn, exports.IconWrapper = function (n) {
  var t = function (n) {
    switch (n) {
      case exports.IconSize.ExtraSmall:
        return 12;

      case exports.IconSize.Small:
        return 16;

      case exports.IconSize.Medium:
        return 24;

      case exports.IconSize.Large:
        return 36;

      default:
        return 24;
    }
  }(null != n.size ? n.size : exports.IconSize.Medium);

  return u.default.createElement("svg", _i({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: null != n.width ? n.width : t,
    height: null != n.height ? n.height : t,
    style: {
      fill: "currentColor"
    },
    viewBox: "0 0 24 24",
    autoReverse: n.autoReverse
  }, n), n.children);
}, exports.ImageTools = Gn, exports.RootRoute = "/", exports.ScrollToTopController = function (n) {
  var e = n.location,
      r = e.pathname,
      o = e.search;
  return t.useEffect(function () {
    window.scrollTo(0, 0);
  }, [r, o]), null;
}, exports.commonErrorParser = function (n) {
  var t = Tn.pipe(kn.fromNullable(n));
  return kn.isSome(t) && Wn(t.value) ? [{
    error: t.value.error,
    message: t.value.error_description,
    fields: kn.none
  }] : kn.isSome(t) && _n(t.value) ? t.value.errors.map(function (n) {
    return {
      error: n.errorCode,
      message: n.message,
      fields: kn.map(function (n) {
        return n.map(function (n) {
          return {
            name: n.field,
            message: n.message
          };
        });
      })(kn.fromNullable(n.fieldErrorList))
    };
  }) : [{
    error: "UNKNOWN",
    message: "Unknown error, you may contact administrator",
    fields: kn.none
  }];
}, exports.createOptionalTransform = function (n) {
  return e.createTransform(function (t, e) {
    return -1 === n.indexOf(String(e)) || !(r = t).hasOwnProperty("_tag") || "None" !== r._tag && "Some" !== r._tag ? t : kn.toNullable(t);
    var r;
  }, function (t, e) {
    return -1 !== n.indexOf(String(e)) ? kn.fromNullable(t) : t;
  });
}, exports.createRootRoute = function () {
  for (var n = [], t = 0; t < arguments.length; t++) {
    n[t] = arguments[t];
  }

  return "" + c([""], n).join("/");
}, exports.createRoute = function () {
  for (var n = [], t = 0; t < arguments.length; t++) {
    n[t] = arguments[t];
  }

  return "" + c(n).join("/");
}, exports.idToggleEnhancer = function (n) {
  return t.memo(function (e) {
    var r = e.onChange,
        o = e.id,
        c = e.children,
        a = function (n, t) {
      var e = {};

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && t.indexOf(r) < 0 && (e[r] = n[r]);
      }

      if (null != n && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (r = Object.getOwnPropertySymbols(n); o < r.length; o++) {
          t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(n, r[o]) && (e[r[o]] = n[r[o]]);
        }
      }

      return e;
    }(e, ["onChange", "id", "children"]),
        f = t.useCallback(function (n) {
      return r(n, o);
    }, [r, o]);

    return u.default.createElement(n, _i({}, a, {
      onChange: f
    }), c);
  });
}, exports.imagePath = function (n, t, e, r) {
  return void 0 === e && (e = "png"), void 0 === r && (r = ""), n + "/" + t + (r ? "@" + r : "") + "." + e;
}, exports.isApiError = _n, exports.isOAuthError = Wn, exports.mergeClassName = Jn, exports.reduceRoute = function (n) {
  return function (t) {
    return n === t ? "/" : t.replace(n + "/", "");
  };
}, exports.setAuthHeader = function (n) {
  return function (t) {
    return Pn(Mn(["headers", "Authorization"]), "Bearer " + n, t);
  };
}, exports.setParam = function (n) {
  return function (t) {
    return function (e) {
      return t.replace(n, e);
    };
  };
}, exports.setParams = function () {
  for (var n = [], t = 0; t < arguments.length; t++) {
    n[t] = arguments[t];
  }

  return function (t) {
    return function () {
      for (var e = [], r = 0; r < arguments.length; r++) {
        e[r] = arguments[r];
      }

      return n.reduce(function (n, t, r) {
        return n.replace(t, e[r]);
      }, t);
    };
  };
}, exports.unwrap = function (n) {
  return n.items;
}, exports.wrap = function (n) {
  return {
    items: n
  };
};